import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getToken } from '../helpers/localstorage-helper';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (
      (!request.url.includes('authenticate') &&
        request.url.includes('/admin')) ||
      request.url.includes('is-admin')
    ) {
      console.log('adding Authorization to:', request.url);

      const token = getToken();
      if (token) {
        request = request.clone({
          // setHeaders: {
          //   Authorization: `Bearer ${token}`
          // }
          headers: request.headers.set('Authorization', `Bearer ${token}`),
        });
      }
    }
    return next.handle(request);
  }
}
